import { changeTheme } from '@shared-legacy/ui-kit';

/**
 * Applies custom theme based on data attribute in the document body
 * If a custom primary color is set via data-primary-color attribute,
 * it will override the default theme primary color
 */
export function applyCustomTheme(): void {
  const primary = document.querySelector('body')?.getAttribute('data-primary-color');
  if (!primary) return;

  const currPrimary = document.documentElement.style.getPropertyValue('--h2o-primary500');
  if (primary !== currPrimary) {
    changeTheme({ primary });
  }
}
